export { default as DocumentTableOutlineIcon } from './DocumentTableOutlineIcon';
